module.exports = __webpack_public_path__ + "static/notFoundImage-a533ddc377b826049a29e7c5d7ff1d41.jpg";